import Layout from '@layout/Index'

export const imgFlowProduct = [
  {
    path: '/img-flow-product',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "img-flow-product-table" */ './pages/ImgFlowProductTable.vue'),
        name: '图片流转产品列表',
        meta: {
          title: '图片流转产品列表',
        },
      },
      // {
      //   path: 'create',
      //   component: () => import(/* webpackChunkName: "img-flow-product-form" */ './pages/ImgFlowProductForm.vue'),
      //   name: '添加图片流转产品',
      // },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "img-flow-product-form" */ './pages/ImgFlowProductForm.vue'),
        name: '修改图片流转产品',
        meta: {
          title: '修改图片流转产品',
        },
      },
      {
        path: 'batch/update',
        component: () => import(/* webpackChunkName: "img-flow-product-batch-form" */ './pages/ImgFlowProductBatchForm.vue'),
        name: '批量更新图片流转产品别名',
        meta: {
          title: '批量更新图片流转产品别名',
        },
      },
      // {
      //   path: 'detail/:id',
      //   component: () => import(/* webpackChunkName: "img-flow-product-detail" */ './pages/ImgFlowProductDetail.vue'),
      //   name: '图片流转产品详情',
      // },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/img-flow-product/img-flow-product.route.js